var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinoBadAsync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 145,
    viewBox: "0 0 104 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3234 48.8609H14.6432C11.2062 48.8609 8.41987 51.6471 8.41987 55.0842V129.764C8.41987 133.201 11.2062 135.988 14.6432 135.988H89.3234C92.7605 135.988 95.5468 133.201 95.5468 129.764V55.0842C95.5468 51.6471 92.7605 48.8609 89.3234 48.8609ZM14.6432 40.563C6.62341 40.563 0.12207 47.0644 0.12207 55.0842V129.764C0.12207 137.784 6.62341 144.286 14.6432 144.286H89.3234C97.3433 144.286 103.845 137.784 103.845 129.764V55.0842C103.845 47.0644 97.3433 40.563 89.3234 40.563H14.6432Z",
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6074 80.4965C27.6074 78.2051 29.4649 76.3476 31.7563 76.3476C34.0477 76.3476 35.9052 78.2051 35.9052 80.4965V90.8687C35.9052 93.1601 34.0477 95.0177 31.7563 95.0177C29.4649 95.0177 27.6074 93.1601 27.6074 90.8687V80.4965Z",
    fill: "#000E4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6172 80.4964C69.6172 78.2051 71.4747 76.3475 73.7661 76.3475C76.0575 76.3475 77.915 78.2051 77.915 80.4964V90.8687C77.915 93.1601 76.0575 95.0176 73.7661 95.0176C71.4747 95.0176 69.6172 93.1601 69.6172 90.8687V80.4964Z",
    fill: "#000E4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5277 94.366C51.8787 92.7244 56.724 93.6922 58.5098 94.366C59.5817 94.7705 60.7786 94.2294 61.183 93.1575C61.5875 92.0855 61.0464 90.8887 59.9744 90.4843C57.6114 89.5926 51.6695 88.3689 46.0631 90.4843C44.9912 90.8887 44.4501 92.0855 44.8545 93.1575C45.259 94.2294 46.4558 94.7705 47.5277 94.366Z",
    fill: "#000E4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7229 30.7094C44.7229 27.5588 47.277 25.0047 50.4276 25.0047C53.5783 25.0047 56.1324 27.5588 56.1324 30.7094V43.1561C56.1324 46.3068 53.5783 48.8609 50.4276 48.8609C47.277 48.8609 44.7229 46.3068 44.7229 43.1561V30.7094Z",
    fill: "#000E4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.283 33.3026C61.4287 33.3026 62.3574 34.2314 62.3574 35.3771C62.3574 36.5228 61.4287 37.4515 60.283 37.4515L40.5757 37.4515C39.43 37.4515 38.5012 36.5227 38.5012 35.3771C38.5012 34.2314 39.43 33.3026 40.5757 33.3026L60.283 33.3026Z",
    fill: "#000E4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9101 8.40913C45.3273 8.40913 41.6123 12.1242 41.6123 16.7069V19.2955C41.6123 22.1828 42.7592 24.9518 44.8008 26.9934L48.1763 30.3688L42.3088 36.2363L38.9334 32.8608C35.3356 29.2631 33.3145 24.3835 33.3145 19.2955V16.7069C33.3145 7.54143 40.7446 0.111328 49.9101 0.111328V8.40913Z",
    fill: "#000E4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9076 8.40913C54.4903 8.40913 58.2054 12.1242 58.2054 16.7069V19.2955C58.2054 22.1828 57.0584 24.9518 55.0168 26.9934L51.6414 30.3688L57.5088 36.2363L60.8843 32.8608C64.482 29.2631 66.5032 24.3835 66.5032 19.2955V16.7069C66.5032 7.54143 59.0731 0.111328 49.9076 0.111328V8.40913Z",
    fill: "#000E4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9525 126.653V104.871C67.3922 111.346 40.6546 111.619 14.9674 105.667L11.5303 104.871V126.653L15.0675 126.092C40.8837 121.999 67.1979 122.189 92.9525 126.653Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoBadAsync);
export default __webpack_public_path__ + "static/media/dinoBadAsync.33309cbce82cfb3c05fd41d9f86d33ef.svg";
export { ForwardRef as ReactComponent };